import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";

import {
  deleteAccountPayable,
  getAllAccountPayables,
  selectAccountPayableForDeletion,
  selectState,
  setIndexForDeletionAccountPayable,
} from "../accountPayable.slice";

const DeleteAccountPayableModal = () => {
  const { deleteAccountPayableModalOpen } = useSelector(selectState);
  const accountPayable = useSelector(selectAccountPayableForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setIndexForDeletionAccountPayable(-1));
  };

  const doDelete = async () => {
    if (accountPayable) {
      try {
        await dispatch(
          deleteAccountPayable(accountPayable.accountPayable.payableId)
        ).unwrap();
        dispatch(
          getAllAccountPayables(accountPayable.accountPayable.partnerId)
        );
        toast.success("Uspesno obrisan.");
        close();
      } catch (status: any) {
        close();
        if (status === 406) {
          toast.info("Brisanje fakture nije moguće dok postoje evidentirana plaćanja.");
        } else if (status === 404) {
          toast.error("Faktura koju tražite da se obriše ne postoji");
        } else if (status === 400) {
          toast.error("Brisanje nije moguće zbog neočekivane greške");
        }
      }
    }
  };

  return (
    <Modal
      isOpen={deleteAccountPayableModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje plaćanja"
    >
      {accountPayable && (
        <p className="info-msg">
          Da li ste sigurni da želite da obrišete sledeće plaćanje?
          <br />
          <br />
          <b>
            br. računa - {accountPayable.accountPayable.invoiceId}
            <br />
            za posao - {accountPayable.project.name}
          </b>
        </p>
      )}
    </Modal>
  );
};

export default DeleteAccountPayableModal;
